/**
 * LLD-SPA-030 — "a duplicate surface has one canonical route; the other identifier is an alias
 * that redirects. There is no second rendering." Populated from `design/27-ui-surface-and-
 * navigation.md` §27.4's own duplicates table, now that all three canonical surfaces are built.
 *
 * `settoken` (the old API-token screen) → `credential` and `drconn` (the old DR-connections
 * screen) → `connected` are both plain top-level redirects — wired as real `<Route>`s in
 * `ShellLayer.tsx` for a bookmarked/typed URL, and resolved here for any in-app `goTo(routeId)`
 * call too, so "a deep link that worked before works after" (§27.4's own words) holds either way.
 *
 * `rrun` (the old object-report screen) → `restorejob` is recorded here for the register's own
 * sake, but is deliberately given no matching `<Route>`: `restorejob` is job-scoped
 * (`/jobs/restore/:jobId`) and §27.4 #1's own resolution lands it on a specific tab ("Restore
 * report") that this build has not built yet (`VRestorejob`'s tabs are
 * summary/repositories/objects/notes/log, no `report`) — inventing a redirect target for a tab
 * that doesn't exist would be guessing, not fixing; reported rather than invented.
 */
export const ROUTE_ALIASES: ReadonlyMap<string, string> = new Map([
  ['rrun', 'restorejob'],
  ['settoken', 'credential'],
  ['drconn', 'connected'],
])

export function resolveCanonicalRouteId(routeId: string): string {
  return ROUTE_ALIASES.get(routeId) ?? routeId
}
